import Header from '../components/Header';
import CourtLineDivider from '../components/CourtLineDivider';
import SportyNerdDeck from '../components/SportyNerdDeck';
import RandomText from '../effects/RandomText';
import SlideInOutText from '../effects/SlideInOutText';
import { Link } from 'react-router-dom';
import SportyNerdDemo from '../components/SportyNerdDemo';
import SportsToggle from '../components/SportsToggle';
import { useState } from 'react';
import UseCase from '../components/UseCase';
import VideoPlayer from '../components/VideoPlayer';
import VideoPlayerMobile from '../components/VideoPlayerMobile';

// https://jinthesportynerd-q8t2roja8-yiyujins-projects.vercel.app/

export default function SportyNerd() {
  const [showAltCollage, setShowAltCollage] = useState(false);

  const outpus = [
    {
      type : "",
      url :  "/collage1.png",
      date : "",
      description : "",
      extraUrl : "",
    }
  ];

  const bucketUrl = "https://storage.googleapis.com/sportynerd-bucket1";

  const tableData = [
    { title: "Timelapse Collage", tech: "MediaPipe Image Segmentation", link: "https://imajin.dev/jinthesportynerd/timelapse-collage/index.html", description: "Capturing Moments from Long Form Videos", verbose : "" },
    { title: "Kinetic Narration", tech: "Cloud Speech-to-Text", link: "https://imajin.dev/jinthesportynerd/kinetic-narration/index.html", description: "Animating Sports Narration from STT", verbose : "Sports narrataions are such a big part of the game. It highlights moments and engages audience. Here, I combined STT and kinetic typos to overlay the narrations to amplify the tone of the narrations." },
    { title: "Sports Slideshow", tech: "Tensorflow.js Object Detection, Document AI", link: "https://imajin.dev/jinthesportynerd/sports-slideshow/index.html", description: "Detecting Objects from many Images", verbose : "" },
    { title: "Text Behind Video/Image", tech: "MediaPipe Image Segmentation", link: "https://imajin.dev/jinthesportynerd/text-behind-video/index.html", description: "Animating Text Behind Segments", verbose : "" },
    { title: "Hand Coding", tech: "Document AI", link: "https://imajin.dev/jinthesportynerd/hand-coding/index.html", description: "Coding with Paper and Pencil",
      verbose : `One's own handwriting can trigger memories surprisingly well. Typing words onto a screen is an “abstract and divided” process and it will have significant educational and practical effects.

<<The Extinction of Experience: Being Human in a Disembodied World>>` },
  ];

  return (
    <div
      className = "sporty-nerd-page"
      style = { { display : "flex", flexDirection : "column", alignItems : "center", justifyContent : "center", textAlign : "center" } }
    >

<div style = { { display : "flex", alignItems : "center", gap : "12px", flexWrap : "wrap" } }>
  <RandomText txt = "Jin" className = "homeText" fontSize = "var(--font-size-huge)" />
  <p className = "homeText" style = { { fontSize : "var(--font-size-tiny)"} }>the</p>
  <p style = { { fontFamily : "Cal Sans", fontSize : "var(--font-size-huge)", paddingLeft : "0px" } }>Sporty</p>
  <SlideInOutText txt = "NERD" prevTxt = "nErD" fontSize = "var(--font-size-huge)" slideInColor = "var(--ptR)" slideOutColor = "var(--ptG)"/>
</div>

<h3 style = { { fontFamily : "Cal Sans", color : "var(--black72)" } }> Dribbling around Sports and Creative</h3>


<h4 className = "caption" style = { { whiteSpace : "pre-wrap" } }>{ `
I use sports as a playful context to build and learn new creative tools and techniques.
My goal is to make creative tools accessible to others and demystify the process.
`}</h4>

<CourtLineDivider/>

<div style = { { display : "flex", alignItems : "center", gap : "4px", flexWrap : "wrap" } }>
  <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)", color : "var(--black40)" } }>&lt;</p>
  <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)" } }>🤜</p>
  <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)", color : "var(--black40)" } }>&gt;</p>
    
  <h3>Overview</h3>

  <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)", color : "var(--black40)" } }>&lt;/</p>
  <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)" } }>🤛</p>
  <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)", color : "var(--black40)" } }>&gt;</p>
</div>


<h4 className = "caption" style = { { whiteSpace : "pre-wrap" } }>{`
Each experiment is like a mini-game, with output examples, use cases, and working demos to show the process.
`}
</h4>
<br/>

{/* TABLE */}
<table style={{ borderCollapse: 'collapse' }}>
  <thead style={ { borderRadius : "8px" }}>
    <tr style={{ background: 'var(--black4)' }}>
      <th style={{ border: '1px solid var(--black16)', padding: '8px' }}>Title</th>
      <th style={{ border: '1px solid var(--black16)', padding: '8px' }}>Tech</th>
      <th style={{ border: '1px solid var(--black16)', padding: '8px' }}>Description</th>
      <th style={{ border: '1px solid var(--black16)', padding: '8px', width: '56px' }}>Link</th>
    </tr>
  </thead>
  <tbody>
    {tableData.map((row, idx) => (
      <tr key={idx}>
        <td style={{ border: '1px solid var(--black16)', padding: '8px', opacity : 0.8 }}>{row.title}</td>
        <td style={{ border: '1px solid var(--black16)', padding: '8px', opacity : 0.8 }}>{row.tech}</td>
        <td className = "caption" style={{ border: '1px solid var(--black16)', padding: '8px' }}>{row.description}</td>
        <td style={{ border: '1px solid var(--black16)', padding: '8px', textAlign: 'center', width: '56px' }}>
          {row.link ? (
            <a href={row.link} target="_blank" rel="noopener noreferrer">
              <img src={bucketUrl + "/iconJoyStick1.png"} style={{ width: "28px", height: "28px" }} alt="link icon" />
            </a>
          ) : null}
        </td>
      </tr>
    ))}
  </tbody>
</table>

<br/>
<div style = {{ display : "flex", flexDirection : "column", alignItems : "stretch", gap : "8px" } }>
  <p>To view all demos, please visit :</p>
  <a href="https://imajin.dev/jinthesportynerd/" target="_blank" rel="noopener noreferrer">
    <img src={bucketUrl + "/iconJoyStick2.png"} style={{ width: "48px", height: "48px" }} alt="link icon" />
  </a>
  <p className = "caption" style = { { textAlign : "center", maxWidth : "100%" } }>https://imajin.dev/jinthesportynerd/</p>
  <VideoPlayer src = "/snreels.mp4" controls = { true } maxHeight = "240px"/>
</div>

<p className = "caption">I also have cookies at the end of this page!</p>

<Header
  title = { tableData[0].title }
  tech = { tableData[0].tech }
  description = { tableData[0].description }
  link = { tableData[0].link }
  verbose = { tableData[0].verbose }
/>

          
  <div className = "sportyNerdDemoContainer" style = { { position : "relative" } }>
    <img src= { bucketUrl + (showAltCollage ? "/collage01.png" : "/collage00.png") } />
    <div style = { {position : "absolute", bottom : "4px", left : "50%" }}>
      <SportsToggle value={showAltCollage} onChange={() => setShowAltCollage(v => !v)} horizontal = { true }/>
    </div>
  </div>

          <UseCase index = "1" title = "Various Motions in one Scene"/>

          <SportyNerdDeck
            title = "Timelaspe Collage"
            tech = "MediaPipe Image Segmentation"
            date = "Cambridge · Thursday, June 26, 2025 · 3:09 PM"
            data = { [
              { type : "img", src : "/collage1.png", caption : "Best Frame" },
              { type : "video", src : "/collage1-videoRaw.MOV", caption : "Original Video (2:37)", controls : true }
            ]}
          />

          <SportyNerdDeck
            title = "Timelaspe Collage"
            tech = "MediaPipe Image Segmentation"
            date = "Seoul · Saturday, June 8, 2024 · 08:55 AM"
            data = { [
              { type : "img", src : "/collage2.png", caption : "Best Frame" },
              { type : "video", src : "/collage2-videoRaw.mov", caption : "Original Video (6:28)", controls : true }
            ]}
          />

          <SportyNerdDeck
            title = "Timelaspe Collage"
            tech = "MediaPipe Image Segmentation"
            date = "New York City · Monday, September 2, 2024 · 09:49 AM"
            data = { [
              { type : "img", src : "/collage4.png", caption : "Best Frame" },
              { type : "video", src : "/collage4-videoRaw.mov", caption : "Original Video"}
            ]}
          />

          
          <UseCase index = "2" title = "Continuous Motion Slices"/>

          <SportyNerdDeck
            title = "Timelaspe Collage"
            tech = "MediaPipe Image Segmentation"
            date = "Seoul · Monday, May 27, 2024 · 08:57 PM"
            data = { [
              { type : "img", src : "/collage5.png", caption : "Best Frame" },
              { type : "video", src : "/collage5-video.mov", caption : "Frame Motion" },
              { type : "video", src : "/collage5-videoRaw.mov", caption : "Original Video" }
            ]}
          />

          <SportyNerdDeck
            title = "Timelaspe Collage"
            tech = "MediaPipe Image Segmentation"
            date = "Seoul · Monday, September 12, 2023 · 09:25 AM"
            data = { [
              { type : "img", src : "/collage6.png", caption : "Best Frame" },
              { type : "video", src : "/collage6-video.mov", caption : "Frame Motion" },
              { type : "video", src : "/collage6-videoRaw.mp4", caption : "Original Video" }
            ]}
          />

          
          <SportyNerdDeck
            title = "Timelapse Collage"
            tech = "MediaPipe Image Segmentation"
            date = "New York City · Saturday, September 21, 2024 · 20:29 PM"
            data = { [
              { type : "img", src : "/collage7.png", caption : "Best Frame" },
              { type : "video", src : "/collage7-video.mov", caption : "Frame Motion" },
              { type : "video", src : "/collage7-videoRaw.mp4", caption : "Original Video" }
            ]}
            caption = "For poor detections, I added manual editor to add segments to the collage, in this case the ball."
          />

          <SportyNerdDeck
            title = "Timelapse Collage"
            tech = "MediaPipe Image Segmentation"
            date = "New York City · Saturday, September 21, 2024 · 20:29 PM"
            data = { [
              { type : "video", src : "/collage8-video.mp4", caption : "Frame Motion" },
              { type : "video", src : "/collage8-videoRaw.mp4", caption : "Original Video" }
            ]}
            caption = "Leaving the last frame on all the time created this effect, like completing a puzzle. Interesting discovery during explorations!"
          />

          <SportyNerdDemo
            iconUrl = "/iconJoyStick1.png"
            videoUrl = "/demo_timelapse.mov"
            link = "https://imajin.dev/jinthesportynerd/timelapse-collage/index.html"
          />



<Header
  title = { tableData[1].title }
  tech = { tableData[1].tech }
  description = { tableData[1].description }
  link = { tableData[1].link }
  verbose = { tableData[1].verbose }
/>

          <SportyNerdDeck
            title = "Kinetic Narration"
            tech = "Cloud Speech-to-Text"
            date = "NBA, Yuki Kawamura's BEST MOMENTS"
            data = { [
              { type : "video", src : "/kinetic1.mov", caption : "Output", controls : true },
              { type : "video", src : "/kinetic2.mov", caption : "Typo Preview", controls : false }
            ]}
            contain={true}
            captionTop = {true}
            soundToggle = { true }
            
          />

          <SportyNerdDeck
            title = "Kinetic Narration"
            tech = "Cloud Speech-to-Text"
            date = "Boston · Saturday, March 21, 2026 · 08:30 AM"
            data = { [
              { type : "video", src : "/kinetic3.mov", caption : "Output", controls : true },
              { type : "video", src : "/kinetic4.mov", caption : "Typo Preview", controls : false }
            ]}
            contain={true}
            captionTop = {true}
            soundToggle = { true }
          />

          <SportyNerdDemo
            iconUrl = "/iconJoyStick1.png"
            videoUrl = "/demo_kineticnarration.mov"
            link = "https://imajin.dev/jinthesportynerd/kinetic-narration/"
          />

          
<br/><br/>
          <h2 style={{lineHeight : 1, paddingTop : "40px" }}>Kinetic Typo Library</h2>
          <p className = "caption">For the kinetic typos used, I published them as a npm library for people to use.</p>

          <SportyNerdDemo
            iconUrl = "/iconJoyStick1.png"
            videoUrl = "/demo_kinetictyposjin.mov"
            link = "https://kinetic-typos-jin-landing.vercel.app/"
            linkText = "Link to Library Page"
            joyStick = { false }
          />

<br/><br/>
          <h2 style={{lineHeight : 1, paddingTop : "40px" }}>Basketball Typo Series</h2>
          <p className = "caption">I am espeically interested in animating sports typos. Starting with some of my favorites : Swish, And One, Steal..</p>
          
          <SportyNerdDemo
            iconUrl = "/iconJoyStick1.png"
            videoUrl = "/bbtyposeries.mp4"
            link = "https://editor.p5js.org/yujin94/collections/PJioam8Kf"
            linkText = "Link to Interactive p5js Sketches"
            joyStick = { false }
            controls = { true }
          />

          <p className = "caption">If you are on Instagram, I tag them here : <Link to = "https://www.instagram.com/explore/search/keyword/?q=bbtyposeries" target = "_blank" style = { { textDecoration : "underline", color : "black" } }>#bbtyposeries</Link></p>
          <p className = "caption" style = { { lineHeight : 1, opacity : 0.5 } }>(Be aware, they have a bug in web version..!)</p>




<Header
  title = { tableData[2].title }
  tech = { tableData[2].tech }
  description = { tableData[2].description }
  link = { tableData[2].link }
  gitHubLink = { tableData[2].gitHubLink }
/>

          <UseCase index = "1" title = "Centering Sportsballs"/>
          
          <SportyNerdDeck
            title = "Sports Slideshow"
            tech = "Tensorflow.js Object Detection"
            date = "Sportsball"
            data = { [
              { type : "video", src : "/output0.mp4", caption : "Output" },
              { type : "video", src : "/output1.mp4", caption : "Effect" },
            ]}
            square = { true }
          />

          <UseCase index = "2" title = "Centering Jersey Numbers"/>

          <SportyNerdDeck
            title = "Sports Slideshow"
            tech = "Document AI"
            date = "Specific Jersey Number"
            data = { [
              { type : "video", src : "/output2.mov", caption : "Output" },
              { type : "video", src : "/output3.mov", caption : "Effect" },
            ]}
            square = { true }
            caption = "Centering a Specific Backnumber. Created for FC Dobbyshire playing in a league called NYC Footy"
          />

          <SportyNerdDeck
            title = "Sports Slideshow"
            tech = "Document AI"
            date = "Any Jersey Number"
            data = { [
              { type : "video", src : "/output4.mov", caption : "Zoomed Out Ver." },
              { type : "video", src : "/output5.mov", caption : "Effect" },
            ]}
            square = { true }
            caption = "Centering Array of Backnumbers. Effects are added with Canvas Code."
          />

          <SportyNerdDeck
            title = "Sports Slideshow"
            tech = "Document AI"
            date = "Any Jersey Number"
            data = { [
              { type : "video", src : "/output6.mov", caption : "Effect" },
              { type : "video", src : "/output7.mov", caption : "Bounding Box" },
            ]}
            square = { true }
          />


          <SportyNerdDemo
            iconUrl = "/iconJoyStick1.png"
            videoUrl = "/demo_sportsball.mp4"
            link = "https://imajin.dev/jinthesportynerd/object-detection-ball-image-reel/"
            linkText = "Sportsball"
          />

          <SportyNerdDemo
            iconUrl = "/iconJoyStick1.png"
            videoUrl = "/demo_backnumberslideshow.mov"
            link = "https://imajin.dev/jinthesportynerd/back-number-slideshow/"
            linkText = "Jersey Number"
          />


<Header
  title = { tableData[3].title }
  tech = { tableData[3].tech }
  description= { tableData[3].description }
  link = { tableData[3].link }
  verbose = { tableData[3].verbose }
/>

          <UseCase index = "1" title = "Thumbnail for Videos"/>

          <SportyNerdDeck
            title = "Text Behind Video/Image"
            tech = "MediaPipe Image Segmentation"
            date = "New York City · Saturday, September 21, 2024 · 20:29 PM"
            data = { [
              { type : "img", src : "/text-behind-video2-thumb1.png", caption : "Best Frame" },
              { type : "img", src : "/text-behind-video2-thumb2.png", caption : "Best Frame" },
              { type : "video", src : "/text-behind-video2.mov", caption : "Video" }
            ]}
          />

          <SportyNerdDeck
            title = "Text Behind Video/Image"
            tech = "MediaPipe Image Segmentation"
            date = "New York City · Wednesday, April 30, 2025 · 20:34 PM"
            data = { [
              { type : "img", src : "/text-behind-video1-thumb.png", caption : "Best Frame" },
              { type : "video", src : "/text-behind-video1.mov", caption : "Video" }
            ]}
            caption = "Javascript code added to animate text behind the segments."
          />

          <SportyNerdDeck
            title = "Text Behind Video/Image"
            tech = "MediaPipe Image Segmentation"
            date = "Cambridge · Thursday, June 26, 2025 · 3:09 PM"
            data = { [
              { type : "img", src : "/text-behind-video3-thumb.png", caption : "Best Frame" },
              { type : "video", src : "/text-behind-video3.mov", caption : "Video" }
            ]}
            caption = "Placing some text behind* and some text on top* to create weave effect."
          />

          <SportyNerdDemo
            iconUrl = "/iconJoyStick1.png"
            videoUrl = "/demo_textbehindvideo.mov"
            link = "https://imajin.dev/jinthesportynerd/text-behind-video/"
          />


<br/><br/>
          <UseCase index = "2" title = "Game Highlight Thumbnails" caption = "For my product Team Stamps, I'm using the demo to generate highlight thumbnails for amateur basketball players."/>

      
          <VideoPlayerMobile src = "/teamstamps1.mp4"/>
          

          <Link  to = "https://team-stamps.com/pfl/game/2026-03-21/1" target="_blank">
            <p style = { { textDecoration : "underline", color : "black", textSize : "var(--font-size-tiny)", color : "var(--black)" } }>Link to Team Stamps</p>
          </Link> 

          <SportyNerdDemo
            iconUrl = "/iconJoyStick1.png"
            videoUrl = "/demo_textbehindimage.mov"
            link = "https://imajin.dev/jinthesportynerd/text-behind-image/"
          />


<br/><br/>
          <UseCase index = "3" title = "Social Media Contents"/>

          <SportyNerdDeck
            title = "Text Behind Video/Image"
            tech = "MediaPipe Image Segmentation"
            date = "NBA, Yuki Kawamura's BEST MOMENTS"
            data = { [
              { type : "img", src : "/yuki.jpg", caption : "Output Image" },
              { type : "video", src : "/yuki.mp4", caption : "Animation" }
            ]}
            caption = "custom graphics generator for social media contents."
            square = { true }
          />

          <SportyNerdDeck
            title = "Text Behind Video/Image"
            tech = "MediaPipe Image Segmentation"
            date = "Caught off Side, Luka Modric"
            data = { [
              { type : "video", src : "/pfl.mp4", caption : "Animation" },
              { type : "video", src : "/modric.mov", caption : "Animation" }
            ]}
            caption = "custom graphics generator for social media contents."
            square = { true }
          />

          <Link  to = "https://editor.p5js.org/yujin94/sketches/On8kBURdn" target="_blank">
            <p style = { { textDecoration : "underline", color : "black", textSize : "var(--font-size-tiny)", color : "var(--black)" } }>Link to Prototype (top)</p>
          </Link> 

          <Link  to = "https://editor.p5js.org/yujin94/sketches/JuUQ-O6YS" target="_blank">
            <p style = { { textDecoration : "underline", color : "black", textSize : "var(--font-size-tiny)", color : "var(--black)" } }>Link to Prototype (left)</p>
          </Link> 

          <Link  to = "https://editor.p5js.org/yujin94/sketches/zefmACf6V" target="_blank">
            <p style = { { textDecoration : "underline", color : "black", textSize : "var(--font-size-tiny)", color : "var(--black)" } }>Link to Prototype (right)</p>
          </Link> 

<Header
  title = { tableData[4].title }
  tech = { tableData[4].tech }
  description = { tableData[4].description }
  link = { tableData[4].link }
  verbose = { tableData[4].verbose }
/>

          <SportyNerdDemo
            iconUrl = "/iconJoyStick1.png"
            videoUrl = "/demo_handcoding.mp4"
            link = "https://imajin.dev/jinthesportynerd/hand-coding/"
          />

<br/><br/><br/><br/>
          <VideoPlayer src = "/ocr.mp4" controls = { true } caption = "[Disperse Effect] Perhaps after, I can animate the text analyzed!"/>
<br/>
          <VideoPlayer src = "/handcodingchallenge.mp4" caption = "30 Days Hand Coding Challenge was an inspiration for this project."/>




          
        
<CourtLineDivider/>
<h1>Cookies!</h1>
<p>More Experiments and Imaginations around the Topic</p>

<br/>

<Header
  title = "Lifting Counter"
  description = "Now, can I use the tech to help me reach a goal?"
  h2 = { true }
/>
<VideoPlayer src = "/liftingcounter1.mp4" controls = { true } caption = "100 lifts is the goal!"/>
<VideoPlayer src = "/liftingcounter2.mp4" controls = { true } />
<VideoPlayer src = "/shotcounter.mp4" controls = { true } caption = "Freethrow Streak Counter"/>

<Header
  title = "Basketball as an Instrument"
  description = "Sports is performance. Can basketball movement create music?"
  h2 = { true }
/>
<VideoPlayer src = "/music2.mp4" controls = { true } caption = "[Sound] Ball bounce sound triggers drum sound based on the ball's position."/>
<VideoPlayer src = "/music3.mp4" controls = { true } caption = "[Sound] Y position of the ball is mapped to sound scale."/>
<VideoPlayer src = "/musicdemo.mov" controls = { true } caption = "[Sound]"/>
<Link  to = "https://editor.p5js.org/yujin94/sketches/C9BuiDk6u" target="_blank">
  <p style = { { textDecoration : "underline", color : "black", textSize : "var(--font-size-tiny)", color : "var(--black)", paddingBottom : "40px" } }>Link to Prototype</p>
</Link> 
<VideoPlayer src = "/music1.mp4" controls = { true } caption = "[Sound]"/>

<Header
  title = "UI Experiments"
  description = "Exploring alternative motions and interactions"
  h2 = { true }
/>
<VideoPlayer src = "/boundingbox.mov" controls = { true } caption = "Animation ideas for bounding boxes. Transition matters and bounding box can be part of the scene!"/>
<VideoPlayer src = "/ui1.mp4" controls = { true } caption = "Exploring satisfying UI interactions for selecting frames for video analysis. Arrow key press to select."/>
<VideoPlayer src = "/ui2.mp4" controls = { true } />
<Link  to = "https://ui-experiments-ml4d1pctt-yiyujins-projects.vercel.app/" target="_blank">
  <p style = { { textDecoration : "underline", color : "black", textSize : "var(--font-size-tiny)", color : "var(--black)", paddingBottom : "40px" } }>Link to Prototype</p>
</Link> 

<Header
  title = "Basketball to.. Code?!"
  description = "I'm imagining ways to involve physical movements in coding process. (maybe git commit with a basketball shot?!)"
  h2 = { true }
/>
<VideoPlayer src = "/interactivehoop.mp4" controls = { true } caption = "Inspired from my interactive hoop project"/>
<VideoPlayer src = "/isthis3pt.mov" controls = { true } caption = "Is this a 3pt?"/>

<CourtLineDivider/>
<h1>Thank you for watching.</h1>

<div style = { { display : "flex", alignItems : "center", gap : "8px", } }>
  <h3>See you on the</h3>
  <SlideInOutText txt = "COURT" prevTxt = "PITCH" fontSize = "var(--font-size-medium)" slideInColor = "var(--orange)" slideOutColor = "var(--green)" speed = {2000} round = {100} />
  <h3>!!</h3>
</div>

<br/>
<img src = "/sticker.gif" style = { { width : "160px", height : "160px" } } alt = "sticker"/>


{/* sticker pack https://editor.p5js.org/yujin94/sketches/jg3lqbhfA */}

    </div>
  );
}